import React,{ useEffect, useState, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// import { useTranslation } from "react-i18next";
import "./index.scss";

import { sideMenuArrowRightIcon, sideMenuPlusIcon, sideMenuMinusIocn, sideMenuCloseIcon } from "../../../../utils/icons";

const SideMenu = ({toggleMenuUpdate}) => {

    // const { t } = useTranslation();

    const location = useLocation();

    const navigate = useNavigate();

    const [menuOpen, setMenuOpen] = useState(true);
    const [activeMenuOne, setActiveMenuOne] = useState("exposureManaganemt");
    const [activeMenuTwo, setActiveMenuTwo] = useState("exposureDashboard");
    const [activeMenuThree, setActiveMenuThree] = useState("");

    //destructuring pathname from location
    const { pathname } = location;
    const queryParams = new URLSearchParams(location.search);

    //Javascript split method to get the name of the path in array
    const splitLocation = useMemo(() => pathname.split("/"), [pathname]);

    const customerId = queryParams.get('customer');
    const organizationId = queryParams.get('organization');
    const domainId = queryParams.get('domain');
    const scanId = queryParams.get('scanId');

    const menuData = useMemo(() => [
        {
          title: 'Exposure Management',
          id: 'exposureManaganemt',
          activekeyOne: 'exposure',
          items: [
            { 
                label: 'Dashboard',
                id: 'exposureDashboard',
                icon: sideMenuArrowRightIcon(),
                activekeyTwo: "dashboard",
                link:`/scan-info/exposure/dashboard?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}`,
            },
            {
              label: 'Asset Discovery',
              id: 'assetDiscovery',
              icon: sideMenuArrowRightIcon(),
              activekeyTwo: "asset-discovery",
              subItems: [
                { id: 'domainInfo', label: 'Domain Info', activekeyThree: "domain-info", link: `/scan-info/exposure/asset-discovery/domain-info?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                { id: 'associateDomain', label: 'Associated Domain', activekeyThree: "associated-domain", link: `/scan-info/exposure/asset-discovery/associated-domain?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                { id: 'subDomainInfo', label: 'Subdomain', activekeyThree: "sub-domain", link: `/scan-info/exposure/asset-discovery/sub-domain?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                { id: 'ipAddress', label: 'IP Address', activekeyThree: "ip-address", link: `/scan-info/exposure/asset-discovery/ip-address?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                { id: 'mobileApps', label: 'Mobile Apps', activekeyThree: "mobile-apps", link: `/scan-info/exposure/asset-discovery/mobile-apps?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },                
                { id: 'dnsRecords', label: 'DNS Records', activekeyThree: "dns-records", link: `/scan-info/exposure/asset-discovery/dns-records?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                { id: 'technologies', label: 'Technologies', activekeyThree: "technologies", link: `/scan-info/exposure/asset-discovery/technologies?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                { id: 'sslRecords', label: 'SSL Certificate', activekeyThree: "ssl-records", link: `/scan-info/exposure/asset-discovery/ssl-records?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` }
              ]
            },
            { 
                label: 'Corporate Email Risk', 
                id: 'corporateEmailRisk',
                activekeyTwo: "corporate-email-risk",
                icon: sideMenuArrowRightIcon() ,
                link:`/scan-info/exposure/corporate-email-risk?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}`,
            },
            { 
                label: 'Concerning Exposure',
                id: 'concerningExposure',
                icon: sideMenuArrowRightIcon(),
                activekeyTwo: "concerning-exposure",
                subItems: [                    
                    { id: 'gitleaks', label: 'Git Leaks', activekeyThree: "git-leaks", link: `/scan-info/exposure/concerning-exposure/git-leaks?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                    { id: 'JSSecrets', label: 'JS Secrets', activekeyThree: "js-secrets", link: `/scan-info/exposure/concerning-exposure/js-secrets?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                    { id: 'sensitiveExposure', label: 'Sensitive Exposure', activekeyThree: "sensitive-exposure", link: `/scan-info/exposure/concerning-exposure/sensitive-exposure?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                ]
            },
            {
                label: 'External Detected Vulnerabilities',
                id: 'externalDetectedVulnerabilities',
                activekeyTwo: "external-detected-vulnerabilities",
                icon: sideMenuArrowRightIcon(),
                subItems: [
                    { id: 'subdomainTakeover', label: 'Subdomain Takeover', activekeyThree: "sub-domain-takeover", link: `/scan-info/exposure/external-detected-vulnerabilities/sub-domain-takeover?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                    { id: 'cves', label: 'CVEs', activekeyThree: "cves", link: `/scan-info/exposure/external-detected-vulnerabilities/cves?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                    { id: 'cnvds', label: 'CNVDs', activekeyThree: "cnvds", link: `/scan-info/exposure/external-detected-vulnerabilities/cnvds?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                    { id: 'sslVulnerabilities', label: 'SSL Vulnerabilities', activekeyThree: "ssl-vulnerabilities", link: `/scan-info/exposure/external-detected-vulnerabilities/ssl-vulnerabilities?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                    { id: 'exposedPanel', label: 'Exposed Panel', activekeyThree: "exposed-panel", link: `/scan-info/exposure/external-detected-vulnerabilities/exposed-panel?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                    { id: 'defaultLogin', label: 'Default Login', activekeyThree: "default-login", link: `/scan-info/exposure/external-detected-vulnerabilities/default-login?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}`},
                    { id: 'misconfiguration', label: 'Misconfiguration', activekeyThree: "misconfiguration", link: `/scan-info/exposure/external-detected-vulnerabilities/misconfiguration?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                    { id: 'otherVulnerabilities', label: 'Other Vulnerabilities', activekeyThree: "other-vulnerabilities", link: `/scan-info/exposure/external-detected-vulnerabilities/other-vulnerabilities?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` }
                ]
            },
            {
              label: 'Dark Web',
              id:"darkWeb",
              icon: sideMenuArrowRightIcon(),
              activekeyTwo: "dark-web",
              subItems: [
                { id: 'leakedCredentials', label: 'Leaked Credentials', activekeyThree: "leaked-credentials", link: `/scan-info/exposure/dark-web/leaked-credentials?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                { id: 'botnetLeaks', label: 'Botnet Leaks', activekeyThree: "botnet-leaks", link: `/scan-info/exposure/dark-web/botnet-leaks?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                { id: 'ransomewareGroupIntel', label: 'Ransomware Group Leaks', activekeyThree: "ransomeware-group-intel", link: `/scan-info/exposure/dark-web/ransomeware-group-intel?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` }
              ]
            },
            { 
                label: 'Brand Insights',
                id: "brandInsight", 
                icon: sideMenuArrowRightIcon(),
                activekeyTwo: "brand-insight",
                subItems: [
                    { id: 'similarDomains', label: 'Similar Domains', activekeyThree: "similar-domain", link: `/scan-info/exposure/brand-insight/similar-domain?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                    { id: 'backlinkAudit', label: 'Backlink Audit', activekeyThree: "backlink-audit", link: `/scan-info/exposure/brand-insight/backlink-audit?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                ]
            }
          ]
        },
        {
            title: 'Third Party Risks',
            id: 'thirdPartyRisk',
            activekeyOne: 'third-party',
            items: [                
                {
                    label: 'Dashboard Overview',
                    id: "dashboardOverview",
                    icon: sideMenuArrowRightIcon(),
                    activekeyTwo: "dashboard-overview",
                    link: `/scan-info/third-party/dashboard-overview?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}`
                },
                {
                    label: 'Vendor Risk Profile',
                    id: "vendorRiskProfile",
                    icon: sideMenuArrowRightIcon(),
                    activekeyTwo: "vendor-risk-profile",
                    link: `/scan-info/third-party/vendor-risk-profile?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}`
                },                
                {
                    label: "Security Overview",
                    id: "securityOverview",
                    icon: sideMenuArrowRightIcon(),
                    activekeyTwo: "security-overview",
                    subItems: [
                        { id: "subdomains", label: "Subdomains", activekeyThree: "subdomains", link: `/scan-info/third-party/security-overview/subdomains?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                        { id: "ipAddresses", label: "IP Addresses", activekeyThree: "ip-address", link: `/scan-info/third-party/security-overview/ip-address?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` }
                    ]
                },
                {
                    label: "Risk Assessment",
                    id: "riskAssessment",
                    icon : sideMenuArrowRightIcon(),
                    activekeyTwo: "risk-assessment",
                    subItems: [
                        { id: "criticaVulnerabilities", label: "Critical Vulnerabilities (CVEs)", activekeyThree: "critical-vulnerabilities", link:`/scan-info/third-party/risk-assessment/critical-vulnerabilities?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                        { id: "subdomainTakeover", label: "Subdomain Takeover", activekeyThree: "subdomain-takeover", link:`/scan-info/third-party/risk-assessment/subdomain-takeover?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                        { id: "sslAndtlsSecurity", label: "SSL/TLS Security", activekeyThree: "sslandtls-security", link:`/scan-info/third-party/risk-assessment/sslandtls-security?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                        { id: 'thirdPartyGitleaks', label: 'Git Leaks', activekeyThree: "git-leaks", link: `/scan-info/third-party/risk-assessment/git-leaks?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}`},
                    ]
                },
                {
                    label: 'Corporate Email Risk',
                    id: "corporateEmailRisk",
                    icon: sideMenuArrowRightIcon(),
                    activekeyTwo: "corporate-email-risk",
                    link: `/scan-info/third-party/corporate-email-risk?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}`
                },
                {
                    label: "Compromise Indicators",
                    id: "compromiseIndicators",
                    icon: sideMenuArrowRightIcon(),
                    activekeyTwo: "compromise-indicators",
                    subItems: [
                        { id: "botnetInfiltrations", label: "Botnet Infiltrations", activekeyThree: "botnet-infiltrations", link: `/scan-info/third-party/compromise-indicators/botnet-infiltrations?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                        { id: "credentialsLeaks", label: "Credentials Leaks", activekeyThree: "credentials-leaks", link: `/scan-info/third-party/compromise-indicators/credentials-leaks?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                        { id: 'ransomewareGroupLeaks', label: 'Ransomware Group Leaks', activekeyThree: "ransomeware-group-leaks", link: `/scan-info/third-party/compromise-indicators/ransomeware-group-leaks?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` }
                    ]
                },
                { 
                    label: 'Brand Insight',
                    id:"brandInsight", 
                    icon: sideMenuArrowRightIcon(),
                    activekeyTwo: "brand-insight",
                    subItems: [
                        { id: 'DomainSimilarities', label: 'Domains Similarities', activekeyThree: "domain-similarities", link: `/scan-info/third-party/brand-insight/domain-similarities?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}` },
                    ]
                },                
            ]
        },
        {
            title: 'Portfolio Risk',
            id: 'portfolioRisk',
            activekeyOne: 'portfolio',
            items: [
                { 
                    label: 'Dashboard',
                    id:"porfolioDashboard", 
                    icon: sideMenuArrowRightIcon(),
                    activekeyTwo: "dashboard",
                    link:`/scan-info/portfolio/dashboard?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}`,
                }
            ]
        },
        {
            title: 'Reports',
            id: 'reports',
            activekeyOne: 'reports',
            items: [
                { 
                    label: 'Exposure Management', 
                    id:"exposureManagement",
                    icon: sideMenuArrowRightIcon() ,
                    activekeyTwo: "exposure-management",
                    link:`/scan-info/reports/exposure-management?customer=${customerId}&organization=${organizationId}&domain=${domainId}&scanId=${scanId}`,
                }
            ]
        }
    ], [customerId, organizationId, domainId, scanId]); // Empty dependency array so it's only computed once

    const MenuOne = ({ id, activekeyOne,title, items, activeMenuOne, setActiveMenuOne, activeMenuTwo, setActiveMenuTwo, activeMenuThree, setActiveMenuThree }) => (
        <>
            <div className={`menu-one-container ${(splitLocation[2] === activekeyOne) ? 'active' : ''}`}>
                <div className="d-flex align-items-center justify-content-between menu-one-heading py-3">
                    <p className="px-3" onClick={() => setActiveMenuOne(id)}>{title}</p>
                    <span className="px-3" >{(splitLocation[2] === activekeyOne) ?  sideMenuMinusIocn() : sideMenuPlusIcon()}</span>
                </div>
                {activeMenuOne === id && <div className="menu-two-container">
                    {items.map((item) => (
                        <MenuTwo
                            key={item.label}
                            activekeyOne={activekeyOne}
                            activekeyTwo={item.activekeyTwo}
                            id={item.id}
                            label={item.label}
                            icon={item.icon}
                            items={item.subItems}
                            activeMenuTwo={activeMenuTwo}
                            setActiveMenuTwo={setActiveMenuTwo}
                            activeMenuThree={activeMenuThree}
                            setActiveMenuThree={setActiveMenuThree}
                            link={item.link}
                        />
                    ))}
                </div> }           
            </div>
            <div className="menu-border-bottom"></div>
        </>
    );

    const MenuTwo = ({ id, activekeyOne, activekeyTwo, link, label, icon, items, activeMenuTwo, setActiveMenuTwo, activeMenuThree, setActiveMenuThree }) => (
        <div className={`menu-two-heading py-2 ${splitLocation[2] === activekeyOne && splitLocation[3] === activekeyTwo ? 'active' : ''}`}>
            <div className="menu-two-contnet" onClick={() =>{
                if(items) {
                    if(activeMenuTwo !== id) {
                        setActiveMenuTwo(id)
                    } else {
                        setActiveMenuTwo("")
                    }                    
                } else {
                    navigate(link)
                }
                
            }}>
                {items && <span className={`arrow-right ${items ? "" : 'no-sub-menu'}`} >{icon || sideMenuArrowRightIcon()}</span>}
                <p className={`${items ? "" : 'no-menu'}`}>{label}</p>
            </div>
            {items && activeMenuTwo === id && (
                <MenuThree items={items} />
            )}
        </div>
    );

    const MenuThree = ({ items }) => (
        <div className="menu-three-container">
            {items.map((item) => (
                <div
                    key={item.id}
                    className={`menu-three-list ${splitLocation[4] === item.activekeyThree ? 'active' : ''}`}
                    onClick={() => {
                        navigate(item.link)
                        setActiveMenuThree(item.id)
                    }}
                >
                    {item.label}
                </div>
            ))}
        </div>
    );

    const toggleMenu = () => {
        setMenuOpen(!menuOpen)
    }

    useEffect(()=>{
        toggleMenuUpdate(menuOpen)
    },[menuOpen, toggleMenuUpdate])

    useEffect(()=>{
        let menuOne = menuData.find(item => splitLocation[2] === item.activekeyOne);
        let menuTwo = menuOne?.items.find(item => splitLocation[3] === item.activekeyTwo);
        setActiveMenuOne(menuOne?.id);
        setActiveMenuTwo(menuTwo?.id);
    },[menuData, splitLocation])

    return (
        <>            
            <div className="menu-list-wrapper">
                {menuData.map((menuOne) => (
                    <MenuOne
                        key={menuOne.title}
                        activekeyOne={menuOne.activekeyOne}
                        id={menuOne.id}
                        title={menuOne.title}
                        items={menuOne.items}
                        activeMenuOne={activeMenuOne}
                        setActiveMenuOne={setActiveMenuOne}
                        activeMenuTwo={activeMenuTwo}
                        setActiveMenuTwo={setActiveMenuTwo}
                        activeMenuThree={activeMenuThree}
                        setActiveMenuThree={setActiveMenuThree}
                    />
                ))}
            </div>
            <div className="menu-close-div" onClick={()=>{toggleMenu()}}>
                <span>{sideMenuCloseIcon()}</span>
                <span>{sideMenuCloseIcon()}</span>
            </div>
        </>
    )
}

export default SideMenu;